import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";

import { Grid, Typography, FormControl, Select, MenuItem } from "@mui/material";

import ButtonBlue from "../../../../shared/general/ButtonBlue";

import DrawerCustom from "../../../../shared/general/Drawer";

import { updateUser } from "../../../../../../actions/user";
import { getEmployeeProfile } from "../../../../../../actions/employee";

const StyledRoot = styled("div")({
  width: 450,
  padding: 24,
  "& .field-label": {
    paddingBottom: 4,
  },
});

const StyledContentLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
});

const StyledFooter = styled("div")({
  padding: 16,
  display: "flex",
  justifyContent: "flex-end",
  "& .cancel": {
    marginRight: 8,
  },
});

const StyledFormControl = styled(FormControl)({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px",
    },
    "& .MuiInputBase-inputMultiline": {
      padding: 0,
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 360,
    },
  },
};

const Payroll = (props) => {
  const { formData, handleChange } = props;
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          คำนวณเงินเดือน ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isPayroll"
            value={formData.isPayroll}
            onChange={handleChange}
            MenuProps={MenuProps}
          >
            <MenuItem value={1}>ใช่</MenuItem>
            <MenuItem value={0}>ไม่ใช่</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          คำนวณกองทุนสำรองเลี้ยงชีพ ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isPf"
            value={formData.isPf}
            onChange={handleChange}
          >
            <MenuItem value={1}>ใช่</MenuItem>
            <MenuItem value={0}>ไม่ใช่</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          คำนวณภาษีเงินได้ ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isTax"
            value={formData.isTax}
            onChange={handleChange}
          >
            <MenuItem value={1}>ใช่</MenuItem>
            <MenuItem value={0}>ไม่ใช่</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          การจ่ายภาษีเงินได้ ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isSelfTaxPaid"
            value={formData.isSelfTaxPaid}
            onChange={handleChange}
          >
            <MenuItem value={1}>พนักงานจ่ายภาษีเงินได้</MenuItem>
            <MenuItem value={0}>บริษัทจ่ายภาษีเงินได้</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          เงินได้ตามมาตรา ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="incomeUnderSection"
            value={formData.incomeUnderSection}
            onChange={handleChange}
          >
            <MenuItem value={"40(1)"}>40(1)</MenuItem>
            <MenuItem value={"40(2)"}>40(2)</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          คำนวณประกันสังคม ?
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isSso"
            value={formData.isSso}
            onChange={handleChange}
          >
            <MenuItem value={1}>ใช่</MenuItem>
            <MenuItem value={0}>ไม่ใช่</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
    </Grid>
  );
};

const DialogEdit = (props) => {
  const { open, mode, handleCloseDialog } = props;
  const dispatch = useDispatch();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (open) {
      setFormData({
        idEmployees: employeeProfile.idEmployees,
        isPayroll: employeeProfile.isPayroll,
        isPf: employeeProfile.isPf,
        isTax: employeeProfile.isTax,
        isSelfTaxPaid: employeeProfile.isSelfTaxPaid,
        isSso: employeeProfile.isSso,
        incomeUnderSection: employeeProfile.incomeUnderSection,
      });
    }
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    let data = { ...formData };
    data.UpdateBy = userProfile.idEmployees;
    console.log("data: ", data)
    const result = await dispatch(updateUser(data));
    if (result) {
      handleCloseDialog();
      dispatch(getEmployeeProfile(employeeProfile.idEmployees, true));
    }
  };

  return (
    <DrawerCustom
      title={"ตั้งค่าการทำเงินเดือน"}
      anchor={"right"}
      open={open}
      onClose={handleCloseDialog}
    >
      <StyledRoot>
        <Payroll formData={formData} handleChange={handleChange} />
        <StyledFooter>
          <ButtonBlue className="cancel" onClick={handleCloseDialog}>
            ยกเลิก
          </ButtonBlue>
          <ButtonBlue variant="contained" onClick={handleSubmit}>
            บันทึกข้อมูล
          </ButtonBlue>
        </StyledFooter>
      </StyledRoot>
    </DrawerCustom>
  );
};

export default DialogEdit;
